import OpportunityPostingImg from "@skv/assets/gfx/partner-programs/opportunity-posting.png";
import RecieveApplicationsImg from "@skv/assets/gfx/partner-programs/recieve-applications.png";

export const WhatsPossible = () => {
  return (
    <section
      className="py-5 mb-5"
      css={`
        border-top: 2px solid ${(p) => p.theme.gray400};
        border-bottom: 2px solid ${(p) => p.theme.gray400};
      `}
    >
      <h2 className="text-center">What's possible</h2>
      <div className="row">
        <div className="col-10 offset-1 mb-2">
          {whatsPossible.map((item, idx) => (
            <article
              key={idx}
              className="d-flex flex-column flex-md-row align-items-center gap-3 gap-md-5 pt-3 mt-4"
            >
              <img
                className="img-fluid"
                src={item.icon}
                alt={item.alt}
                width={100}
                height={100}
              />
              <div>
                <h3 className="h4">{item.title}</h3>
                <p className="mb-0">{item.body}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

const whatsPossible = [
  {
    icon: OpportunityPostingImg,
    alt: "An opportunity displayed on computer and mobile screens",
    title: "Opportunity Posting",
    body: "Post your volunteer opportunities within your VMS and your opportunity will automatically get pushed to SEEK Volunteer.",
  },
  {
    icon: RecieveApplicationsImg,
    alt: "Hand selecting an application",
    title: "Receive Applications",
    body: "Data from applications will automatically transfer into your VMS, eliminating the need for manual data entry and ensure you never miss an application.",
  },
];
